import {axiosIns} from 'config/api.config'

export const DashboardService = {
  getEmpByGender: async (): Promise<any> => await axiosIns.get(`/dashboard/get-emp-by-gender`),

  // Aggregated HR metrics — the HR/admin dashboard (confidential, company-wide)
  getHrSummary: async (): Promise<any> => await axiosIns.get(`/dashboard/hr-summary`),

  // Current user's mini-profile + direct-report count (drives dashboard gating)
  getMyContext: async (): Promise<any> => await axiosIns.get(`/dashboard/me`),

  // Self-service summary — the default employee dashboard
  getEmployeeSummary: async (): Promise<any> => await axiosIns.get(`/dashboard/employee-summary`),

  // Team-only summary — the line-manager dashboard
  getTeamSummary: async (): Promise<any> => await axiosIns.get(`/dashboard/team-summary`),

  // Setup-completeness checklist — company-admin onboarding nudge (missing core master data)
  getSetupChecklist: async (): Promise<any> => await axiosIns.get(`/dashboard/setup-checklist`),
}
